import moment from "moment"

// ------------------------- Interfaces -------------------------

// ------------------------- Functions -------------------------
// uniqueArray - removes duplicate values from an array
// capitalizeFirstLetter - capitalizes the first letter of a string
// getDateRange - returns a date range string for the last N days
// shortenedString - truncates a string to max length with ellipsis
// removeBlankAttributes - removes null, undefined, or empty string properties from an object
// parseGS1String - parses GS1 barcode string and extracts GTIN, expiry, batch, and serial
//

// ----------------------------- uniqueArray ---------------------------------
export const uniqueArray = (array: any[]) => {
  return array.filter((value, index, self) => {
    return self.indexOf(value) === index
  })
}

// ----------------------------- capitalizeFirstLetter ---------------------------------
export const capitalizeFirstLetter = (str: string) => {
  if (!str || !str?.length) return ""
  const strWord = str?.toLowerCase()
  // COD (cash on delivery) is an acronym and always stays in capitals.
  return (strWord?.charAt(0)?.toUpperCase() + strWord?.slice(1)).replace(/\bcod\b/gi, "COD")
}

// ----------------------------- getDateRange ---------------------------------
export const getDateRange = (lastDays: number) =>
  [moment().subtract(lastDays, "days").format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")].join("/")

// ----------------------------- shortenString ---------------------------------
export const shortenString = ({ str = "", maxLength = 10 }: { str: string; maxLength?: number }) => {
  if (str?.length <= maxLength) return str
  else return str?.slice(0, maxLength - 3) + "..."
} // take "123456789abcdefg" |  return "1234567..."

export const shortenStringMiddle = (s: string, head = 8, tail = 4) => {
  if (!s) return s
  if (s.length <= head + tail + 3) return s
  return `${s.slice(0, head)}...${s.slice(-tail)}`
} // take "010896400166958610U160" | return "01089640...U160"

// ----------------------------- removeBlankAttributes ---------------------------------
export const removeBlankAttributes = <T>(data: T): T => {
  const obj = { ...data }

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
        delete obj[key as keyof T]
      }
    }
  }
  return obj
}
